// extracted by mini-css-extract-plugin
export default {"priceContainer":"lga-z","discountedPrice":"mga-z","originalPrice":"nga-z","productPrice":"oga-z"};